import React from 'react'
import styled from 'styled-components'
import StopProgram from './StopProgram'
import RetakeProgram from './RetakeProgram'
const Container = styled.div`
  width: 480px;
  margin-bottom: 46px;
  max-width: 100%;
`
const CpmpletedText = styled.p`
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  text-align: initial;
  @media (max-width: 600px) {
    font-size: 16px;
    font-style: normal;
    line-height: 135%;
    letter-spacing: 0.8px;
  }
`

const Bar = styled.div`
  height: 8px;
  background-color: #ccc;
  border-radius: 0 6px 6px 0;
  overflow: hidden;
  @media (max-width: 600px) {
    height: 6px;
  }
`

const Heading = styled.div`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.84px;
  text-transform: uppercase;
  text-align: initial;
  margin-bottom: 12px;
`

const Progress = styled.div({
  width: (props) => props.percentage + '%',
  backgroundColor: '#3b3b3b',
  transition: 'width 0.3s ease-in-out',
  height: '100%'
})

const ProgressBar = ({ id, completed, total, status }) => {
  const percentage = (completed / total) * 100
  const shouldShowProgressBar = ['in_progress', 'completed'].includes(status)
  return (
    <Container>
      {shouldShowProgressBar && (
        <>
          <Heading>
            {status === 'completed'
              ? 'PROGRAM COMPLETE!'
              : 'Program In progress'}
          </Heading>
          <CpmpletedText>
            {completed} of {total} completed
          </CpmpletedText>

          <Bar>
            <Progress percentage={percentage} />
          </Bar>
        </>
      )}
      {status === 'in_progress' && <StopProgram id={id} />}
      {status === 'completed' && <RetakeProgram id={id} />}
    </Container>
  )
}

export default ProgressBar
